import moment from 'moment';
import isHoliday from '../../../constants/holidays';

export const PAYMENT_DATE_DISABLE_MESSAGES = {
  ALTERED_TODAY: 'Já foi realizada uma alteração de data de pagamento hoje, por favor tente novamente em outro dia.',
  DEADLINE_EXPIRED: 'Não é possível alterar: o prazo limite para alteração desta folha expirou.',
  CNAB_SCHEDULED: 'Não é possível alterar: o pagamento já foi enviado para a instituição financeira.',
  HOLIDAY: 'Feriado — pagamentos não são processados neste dia',
  WEEKEND: 'A data não pode ser final de semana',
  PAST_DATE: 'Não é possível antecipar o pagamento para uma data no passado',
  TODAY_AFTER_11H: 'Já passou das 11h, você perdeu o prazo da antecipação para hoje... :(',
  BEYOND_WINDOW:
    'Não é possível alterar: a nova data deve estar em até 7 dias corridos a contar da data de pagamento atual.',
};

const TODAY_ANTICIPATION_CUTOFF_HOUR = 11;
const PAYMENT_CHANGE_DEADLINE_HOUR = 12;
const POSTPONE_MAX_CALENDAR_DAYS = 7;

const resolveCurrentPaymentDate = (payroll) => {
  const raw = payroll.paymentDateAdjustedByManager || payroll.dataPrevistaPagamentoCooperado;
  return raw ? moment(raw).startOf('day') : null;
};

const hasPaymentChangeDeadlineExpired = (now, currentPaymentDate) => {
  const deadline = currentPaymentDate
    .clone()
    .subtract(1, 'day')
    .hour(PAYMENT_CHANGE_DEADLINE_HOUR)
    .minute(0)
    .second(0)
    .millisecond(0);
  return now.isAfter(deadline);
};

/**
 * @returns {string|null} Motivo legível se a data deve ficar desabilitada; null se selecionável.
 */
export function getPaymentDateDisableReason({ current, payroll, isAdmin, now = moment() }) {
  if (isAdmin || !current) {
    return null;
  }

  if (
    payroll.dataLancamentoPedidoAntecipacaoPagamento &&
    moment(payroll.dataLancamentoPedidoAntecipacaoPagamento).isSame(now, 'day')
  ) {
    return PAYMENT_DATE_DISABLE_MESSAGES.ALTERED_TODAY;
  }

  const currentPaymentDate = resolveCurrentPaymentDate(payroll);
  if (!currentPaymentDate) {
    return null;
  }

  if (hasPaymentChangeDeadlineExpired(now, currentPaymentDate)) {
    return PAYMENT_DATE_DISABLE_MESSAGES.DEADLINE_EXPIRED;
  }

  if (payroll.cnabPaymentDate) {
    return PAYMENT_DATE_DISABLE_MESSAGES.CNAB_SCHEDULED;
  }

  if (isHoliday(current)) {
    return PAYMENT_DATE_DISABLE_MESSAGES.HOLIDAY;
  }

  if (current.day() === 0 || current.day() === 6) {
    return PAYMENT_DATE_DISABLE_MESSAGES.WEEKEND;
  }

  if (current.isBefore(now, 'day')) {
    return PAYMENT_DATE_DISABLE_MESSAGES.PAST_DATE;
  }

  const todayCutoff = now
    .clone()
    .startOf('day')
    .hour(TODAY_ANTICIPATION_CUTOFF_HOUR)
    .minute(0)
    .second(0)
    .millisecond(0);
  if (current.isSame(now, 'day') && now.isAfter(todayCutoff)) {
    return PAYMENT_DATE_DISABLE_MESSAGES.TODAY_AFTER_11H;
  }

  const maxPostponeDate = currentPaymentDate.clone().add(POSTPONE_MAX_CALENDAR_DAYS, 'days');
  if (current.isAfter(maxPostponeDate, 'day')) {
    return PAYMENT_DATE_DISABLE_MESSAGES.BEYOND_WINDOW;
  }

  return null;
}
